import React, { useEffect, useState } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { contactReligionDetailSchema } from "./ValidationSchema";
import {
  getCountry,
  getState,
  getCity,
  getDomain,
  getReligion,
  getCast,
  addContactReligionDetails,
} from "../asiosConfig";
import { Grid, Button, MenuItem, Select, CircularProgress } from "@mui/material";

import CommonPopup from "./CommonPopup";

const RegisterContactStep = ({ onNext, registrationData }) => {
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [domains, setDomains] = useState([]);
  const [religions, setReligions] = useState([]);
  const [casts, setCasts] = useState([]);
  const [indiaId, setIndiaId] = useState("");
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  const [popup, setPopup] = useState({
    open: false,
    type: "", // "success" | "error"
    message: "",
  });

  const [isSuccess, setIsSuccess] = useState(false);

  const initialValues = {
    address: "",
    pincode: "",
    area: "",
    city: "",
    state: "",
    country: indiaId,
    caste: "",
    religion: "",
    citizenship: indiaId,
    domain: "",
    specialmobileNumber: "",
    user_id: registrationData?.user_id || localStorage.getItem("user"),
    token: registrationData?.token || localStorage.getItem("token"),
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [counRes, domRes] = await Promise.all([
          getCountry(),
          getDomain(),
        ]);
        const countriesData = counRes.data.data || [];
        setCountries(countriesData);
        const india = countriesData.find(
          (c) => c.country.toLowerCase() === "india"
        );
        if (india) {
          setIndiaId(india.id);
          initialValues.country = india.id;
          initialValues.citizenship = india.id;
        }
        setDomains(domRes.data.data || []);
      } catch (error) {
        setPopup({
          open: true,
          type: "error",
          message: "Failed to fetch cities",
        });
      }
    };
    fetchData();
  }, []);

  const handleCountryChange = async (countryId, setFieldValue) => {
    setFieldValue("country", countryId);
    setFieldValue("state", "");
    setFieldValue("city", "");
    try {
      const response = await getState(countryId);
      setStates(response.data.data || []);
    } catch (error) {
      // setPopupMessage('Failed to fetch states');
      // setPopupOpen(true);

      setPopup({
        open: true,
        type: "error",
        message: "Failed to fetch states",
      });
    }
  };

  const handleStateChange = async (stateId, setFieldValue) => {
    setFieldValue("state", stateId);
    setFieldValue("city", "");
    try {
      const response = await getCity(stateId);
      setCities(response.data.data || []);
    } catch (error) {
      setPopupMessage("Failed to fetch cities");
      setPopupOpen(true);
    }
  };

  const handleDomainChange = async (domainId, setFieldValue) => {
    setFieldValue("domain", domainId);
    setFieldValue("religion", "");
    setFieldValue("caste", "");
    try {
      const response = await getReligion({ Domain_id: domainId });
      setReligions(response.data.data || []);
    } catch (error) {
      setPopup({
        open: true,
        type: "error",
        message: "Failed to fetch religions",
      });
    }
  };

  const handleReligionChange = async (religionId, setFieldValue) => {
    setFieldValue("religion", religionId);
    setFieldValue("caste", "");
    try {
      const response = await getCast(religionId);
      setCasts(response.data.data || []);
    } catch (error) {
      setPopup({
        open: true,
        type: "error",
        message: "Failed to fetch castes",
      });
    }
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const payload = {
        ...values,
      };
      const response = await addContactReligionDetails(payload);

      // if (response.status === 200 || response.status === 201) {
      //     setPopupMessage('Contact details saved successfully');
      //     setIsSuccess(true);
      //     setPopupOpen(true);
      // } else {
      //     setPopupMessage(response.data.message || 'Failed to save');
      //     setIsSuccess(false);
      //     setPopupOpen(true);
      // }

      if (response.status === 200 || response.status === 201) {
        setPopup({
          open: true,
          type: "success",
          message: "Contact details saved successfully",
        });
      } else {
        setPopup({
          open: true,
          type: "error",
          message: response.data.message || "Failed to save",
        });
      }
    } catch (error) {
      setPopup({
        open: true,
        type: "error",
        message: error.response?.data?.message || "Error saving details",
      });
    } finally {
      setSubmitting(false);
    }
  };

  // const handlePopupClose = () => {
  //     setPopupOpen(false);
  //     if (isSuccess) {
  //         onNext(4);
  //     }
  // };

  const handlePopupClose = () => {
    setPopup({ open: false, type: "", message: "" });

    if (popup.type === "success") {
      localStorage.setItem("register_current_step", 4);
      onNext(4); // Family Details step
    }
  };

  const InputBox = ({
    name,
    value,
    onChange,
    placeholder,
    select,
    children,
    type = "text",
  }) => (
    <div
      style={{
        width: "100%",
        borderRadius: "10px",
        backgroundColor: "#f5fcfe",
        border: "1px solid #d4d4d4",
        height: "40px",
        display: "flex",
        alignItems: "center",
        padding: "0 15px",
        fontFamily: "Montserrat",
      }}
    >
      {select ? (
        <Select
          name={name}
          value={value}
          onChange={onChange}
          displayEmpty
          variant="standard"
          disableUnderline
          fullWidth
          MenuProps={{
            PaperProps: {
              style: {
                backgroundColor: "#f5fcfe",
                borderRadius: "10px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              },
            },
          }}
          sx={{
            fontSize: "15px",
            color: "#333",
            fontFamily: "Montserrat, sans-serif",
            "& .MuiSelect-select": {
              padding: "0 !important",
              fontFamily: "Montserrat",
            },
          }}
        >
          <MenuItem value="" disabled>
            {placeholder}
          </MenuItem>
          {children}
        </Select>
      ) : (
        <input
          name={name}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          style={{
            width: "100%",
            height: "100%",
            border: "none",
            outline: "none",
            background: "transparent",
            fontSize: "15px",
            fontWeight: 500,
            color: "#333",
          }}
        />
      )}
    </div>
  );

  return (
    <div
      style={{
        flex: "1 1 500px",
        // padding: "30px 40px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
      }}
    >
      <Formik
        initialValues={initialValues}
        validationSchema={contactReligionDetailSchema}
        validateOnChange
  validateOnBlur
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ isSubmitting, values, handleChange, setFieldValue , setFieldTouched,  }) => (
          <Form
            style={{
              width: "100%",
              maxWidth: "480px",
              display: "flex",
              flexDirection: "column",
              gap: "12px",
              textAlign: "left",
              fontFamily: "Montserrat",
              width: "100%",
            }}
          >
            {/* Address */}
            <InputBox
              name="address"
              value={values.address}
              onChange={handleChange}
              placeholder="Address"
            />
            <ErrorMessage
              name="address"
              component="div"
              style={{ color: "red", fontSize: "12px", marginTop: "-10px" }}
            />

            {/* Area */}
            <InputBox
              name="area"
              value={values.area}
              onChange={handleChange}
              placeholder="Area"
            />
            <ErrorMessage
              name="area"
              component="div"
              style={{ color: "red", fontSize: "12px", marginTop: "-10px" }}
            />

            {/* Alternate Mobile */}
            <InputBox
              name="specialmobileNumber"
              value={values.specialmobileNumber}
              onChange={(e) => {
                const val = e.target.value;
                if (/^\d*$/.test(val) && val.length <= 10) {
                  handleChange(e);
                }
              }}
              placeholder="Alternate Mobile No"
              type="tel"
            />
            <ErrorMessage
              name="specialmobileNumber"
              component="div"
              style={{ color: "red", fontSize: "12px", marginTop: "-10px" }}
            />

            {/* Country – FULL WIDTH */}
            <InputBox
              name="country"
              value={values.country}
            //   onChange={(e) =>
            //     handleCountryChange(e.target.value, setFieldValue)
            //   }
            onChange={(e) => {
  const value = e.target.value;

  // ✅ country
  setFieldValue("country", value, true);
  setFieldTouched("country", true, false);

  // 🔁 reset dependents
  setFieldValue("state", "", false);
  setFieldTouched("state", false, false);

  setFieldValue("city", "", false);
  setFieldTouched("city", false, false);

  if (value) {
    getState(value)
      .then(res => setStates(res.data.data || []))
      .catch(() => setStates([]));
  } else {
    setStates([]);
    setCities([]);
  }
}}

              placeholder="Country"
              select
            >
              {countries.map((coun) => (
                <MenuItem key={coun.id} value={String(coun.id)}>
                  {coun.country}
                </MenuItem>
              ))}
            </InputBox>
            <ErrorMessage
              name="country"
              component="div"
              style={{ color: "red", fontSize: "12px", marginTop: "-10px" }}
            />

            {/* Native State + Native City */}
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <InputBox
                  name="state"
                  value={values.state}
                //   onChange={(e) =>
                //     handleStateChange(e.target.value, setFieldValue)
                //   }
                onChange={(e) => {
  const value = e.target.value;

  setFieldValue("state", value, true);
  setFieldTouched("state", true, false);

  setFieldValue("city", "", false);
  setFieldTouched("city", false, false);

  if (value) {
    getCity(value)
      .then(res => setCities(res.data.data || []))
      .catch(() => setCities([]));
  } else {
    setCities([]);
  }
}}

                  placeholder="Native State"
                  select
                >
                  {states.map((st) => (
                    <MenuItem key={st.id} value={String(st.id)}>
                      {st.state}
                    </MenuItem>
                  ))}
                </InputBox>
                <ErrorMessage
                  name="state"
                  component="div"
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginBottom: "2px",
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={12}>
                <InputBox
                  name="city"
                  value={values.city}
                //   onChange={handleChange}
                onChange={(e) => {
  const value = e.target.value;
  setFieldValue("city", value, true);
  setFieldTouched("city", true, false);
}}

                  placeholder="Native City"
                  select
                >
                  {cities.map((ct) => (
                    <MenuItem key={ct.id} value={String(ct.id)}>
                      {ct.city}
                    </MenuItem>
                  ))}
                </InputBox>
                <ErrorMessage
                  name="city"
                  component="div"
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginBottom: "2px",
                  }}
                />
              </Grid>
            </Grid>

            {/* Citizenship + Domain */}
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <InputBox
                  name="citizenship"
                  value={values.citizenship}
                  onChange={handleChange}
                  placeholder="Citizenship"
                  select
                >
                  {countries.map((coun) => (
                    <MenuItem key={coun.id} value={String(coun.id)}>
                      {coun.country}
                    </MenuItem>
                  ))}
                </InputBox>
                <ErrorMessage
                  name="citizenship"
                  component="div"
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginBottom: "2px",
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <InputBox
                  name="domain"
                  value={values.domain}
                //   onChange={(e) =>
                //     handleDomainChange(e.target.value, setFieldValue)
                //   }

                onChange={(e) => {
  const value = e.target.value;

  setFieldValue("domain", value, true);
  setFieldTouched("domain", true, false);

  setFieldValue("religion", "", false);
  setFieldTouched("religion", false, false);

  setFieldValue("caste", "", false);
  setFieldTouched("caste", false, false);

  if (value) {
    getReligion({ Domain_id: value })
      .then(res => setReligions(res.data.data || []))
      .catch(() => setReligions([]));
  }
}}

                  placeholder="Domain"
                  select
                >
                  {domains.map((dom) => (
                    <MenuItem key={dom.id} value={dom.id}>
                      {dom.domain}
                    </MenuItem>
                  ))}
                </InputBox>
                <ErrorMessage
                  name="domain"
                  component="div"
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginBottom: "2px",
                  }}
                />
              </Grid>
            </Grid>

            {/* Religion + Caste */}
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <InputBox
                  name="religion"
                  value={values.religion}
                //   onChange={(e) =>
                //     handleReligionChange(e.target.value, setFieldValue)
                //   }
                onChange={(e) => {
  const value = e.target.value;

  setFieldValue("religion", value, true);
  setFieldTouched("religion", true, false);

  setFieldValue("caste", "", false);
  setFieldTouched("caste", false, false);

  if (value) {
    getCast(value)
      .then(res => setCasts(res.data.data || []))
      .catch(() => setCasts([]));
  }
}}

                  placeholder="Religion"
                  select
                >
                  {religions.map((rel) => (
                    <MenuItem key={rel.id} value={rel.id}>
                      {rel.religion}
                    </MenuItem>
                  ))}
                </InputBox>
                <ErrorMessage
                  name="religion"
                  component="div"
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginBottom: "2px",
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <InputBox
                  name="caste"
                  value={values.caste}
                //   onChange={handleChange}
                onChange={(e) => {
  const value = e.target.value;
  setFieldValue("caste", value, true);
  setFieldTouched("caste", true, false);
}}

                  placeholder="Caste"
                  select
                >
                  {casts.map((cast) => (
                    <MenuItem key={cast.id} value={cast.id}>
                      {cast.caste}
                    </MenuItem>
                  ))}
                </InputBox>
                <ErrorMessage
                  name="caste"
                  component="div"
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginBottom: "0px",
                  }}
                />
              </Grid>
            </Grid>

            {/* Submit */}
            <Button
              type="submit"
              variant="contained"
              disabled={isSubmitting}
              style={{
                marginTop: "10px",
                borderRadius: "50px",
                background:
                  "linear-gradient(rgba(255,255,255,0.3), rgba(255,255,255,0.22)), linear-gradient(90deg, #f78c25, #ff3c3c)",
                color: "#fff",
                fontWeight: 600,
                fontSize: "16px",
                height: "49px",
                textTransform: "none",
                fontFamily: "Montserrat",
                boxShadow: "0 4px 8px rgba(255,60,60,0.3)",
                gap: "10px",
              }}
            >

                {isSubmitting && (
    <CircularProgress
      size={20}
      thickness={5}
      sx={{ color: "#fff" }}
    />
  )}
  
              {isSubmitting ? "Saving..." : "Next"}
            </Button>
          </Form>
        )}
      </Formik>
      {/* <Popup open={popupOpen} onClose={handlePopupClose} message={popupMessage} /> */}

      <CommonPopup
        open={popup.open}
        type={popup.type}
        message={popup.message}
        onClose={handlePopupClose}
      />
    </div>
  );
};

export default RegisterContactStep;
